<template>
    <v-container fluid>
      <v-row justify-center>
        <v-col cols="12">
          <v-card
            class="mx-auto"
            :loading="loading"
            @loadingStart="loading = true"
            @loadingStop="loading = false"
          >
            <v-system-bar
              dark
              light
              color="blue-grey darken-1"
              style="color: #fff"
            >
              <v-spacer></v-spacer><b>Sistema de control de oficios</b
              ><v-spacer></v-spacer>
            </v-system-bar>
            <router-view></router-view>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  data: () => ({
    loading: false,
  }),
};
</script>